import "./plan-info-description.scss"
import SubscriptionPlansStore from "../../../stores/subscription-plans-store";
import {observer} from "mobx-react-lite";

export interface IPlanDescription {
    planDescription: string;
    shortPlanDescription: string;
    isContactUsSection: boolean;
}

const PlanDescription: React.FC<IPlanDescription> = observer(({
                                                                  planDescription,
                                                                  shortPlanDescription,
                                                                  isContactUsSection
                                                              }: IPlanDescription) => {
    return (
        <div className={
            `plan-info-description 
            ${!SubscriptionPlansStore.showMore && !isContactUsSection && 'plan-description-collapsed'}
            `
        } dangerouslySetInnerHTML={{__html: !SubscriptionPlansStore.showMore ? shortPlanDescription : planDescription}}/>
    )
});

export default PlanDescription;